import api from '~/services/api';

/**
 * Resolve o prefixo da URL com base no role do usuário.
 * O backend tem rotas duplicadas pra cada role, então a URL muda.
 */
export function getRolePrefix(roles) {
  if (!Array.isArray(roles)) return null;
  if (roles.find(r => r.slug === 'administrator')) return 'administrator';
  if (roles.find(r => r.slug === 'store-manager')) return 'store-manager';
  if (roles.find(r => r.slug === 'cross-manager')) return 'cross-manager';
  if (roles.find(r => r.slug === 'digital-consultant'))
    return 'digital-consultant';
  if (roles.find(r => r.slug === 'support')) return 'administrator';
  return null;
}

function buildUrl(rolePrefix, cartId, suffix = '') {
  return `/${rolePrefix}/carts/${cartId}/delivery/pickup-validation${suffix}`;
}

const pickupValidationService = {
  show(rolePrefix, cartId) {
    return api.get(buildUrl(rolePrefix, cartId));
  },

  start(rolePrefix, cartId) {
    return api.post(buildUrl(rolePrefix, cartId));
  },

  verify(rolePrefix, cartId, payload) {
    return api.post(buildUrl(rolePrefix, cartId, '/verify'), payload);
  },

  // Rota exclusiva do suporte Viddy — prefixo fixo, não derivado da role
  // de navegação (o suporte navega como 'administrator', mas esta ação
  // exige o middleware role:support no backend).
  supportRelease(cartId) {
    return api.post(
      `/support/carts/${cartId}/delivery/pickup-validation/support-release`
    );
  },

  release(rolePrefix, cartId) {
    return api.post(buildUrl(rolePrefix, cartId, '/release'));
  },

  cancel(rolePrefix, cartId, reason = '') {
    return api.delete(buildUrl(rolePrefix, cartId), {
      data: { reason },
    });
  },

  uploadPhoto(rolePrefix, cartId, fileBlob) {
    const formData = new FormData();
    formData.append('photo', fileBlob);

    return api.post(buildUrl(rolePrefix, cartId, '/photo'), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default pickupValidationService;
